export type OnSubmit<T> = (values: T) => void;

export enum EnrollmentType {
  COBRA,
  Retiree,
  LOA,
  Regular,
}
